import {
  DEFAULT_SESSION_TTL_MS,
  isSessionDataExpired,
  loadSessionData,
  saveSessionData,
} from '../../../utils/sessionStorageUtils';
import { TRACKING_DATA_SESSION_KEY_PREFIX } from '../../../utils/sessionStorageKeys';

interface StoredTrackingData<T> {
  data: T;
  savedAt: number;
}

const buildTrackingDataKey = () => {
  const project = window.location.pathname.split('/').filter(Boolean)[0] ?? '';
  return `${TRACKING_DATA_SESSION_KEY_PREFIX}:${project}`;
};

// Restores tracking history on a reload of the same session, ignores it otherwise
// (fresh navigation, a different project, or expired data all fall back to defaults)
export const loadPersistedTrackingData = <T>(defaultData: T): T => {
  const stored = loadSessionData<StoredTrackingData<T>>(buildTrackingDataKey());
  const nav = performance.getEntriesByType?.('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;
  if (
    !stored ||
    isSessionDataExpired(stored.savedAt, DEFAULT_SESSION_TTL_MS) ||
    nav?.type !== 'reload'
  )
    return defaultData;
  return stored.data;
};

export const persistTrackingData = <T>(data: T): void => {
  saveSessionData(buildTrackingDataKey(), { data, savedAt: Date.now() });
};
